import * as React from 'react';
import {useEffect, useState} from 'react';
import {Col, Form, Row} from "react-bootstrap";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import {useNavigate, useParams} from "react-router-dom";
import {Api} from "../../../helpers/Api";
import {withRouter} from "../../../hoc/withRouter.ts";
import {cloneDeep} from 'lodash';
import CertificateViewer from "./CertificateViewer";
import {v4 as uuidv4} from 'uuid';
import LoadingSpinner from '../../v2/Components/Spinner/LoadingSpinner';

// const TEMPLATE_NEW = {
//     id: null,
//     name: "",
//     data: {
//         labels: [],
//         backgroundImageUrl: null,
//         images: [],
//     }
// }


const EditCertificate = ({dispatchLogin, location}) => {

    const [loading, setLoading] = useState(true);
    const [event, setEvent] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [template, setTemplate] = useState(null);   
    const [certificate, setCertificate] = useState({data: {}, email:'', template: {data: {}}});
    const [selectedEvent, setSelectedEvent] = useState();
    const [isDisabled, setIsDisabled] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    
    const navigate = useNavigate();
    const {id} = useParams();

    useEffect(() => {

        window.addEventListener('click', function(event) {
            if(event && event?.target && event?.target?.className?.includes("WClick")){
                setShowSearch(true);
            }
            else{
                setShowSearch(false);
            }
        });

        Api.call(`/getTemplateData`)
        .then(response => {
            setEvent(response);         
            // if (response.length > 0) {
            //     setTemplates(t => (t || response[0]))
            // }
        }).finally(()=>{
            setLoading(false);
        });
    }, []);
    useEffect(() => {
        if(id !== "new")
        {
        Api.getCertificate(id).then(response => {
            setCertificate(response);
            setTemplate(response.templateData);
            setSelectedEvent(response.template);  
            
            setIsDisabled(true);
        })
        }
    }, [id])

    // useEffect(() => {
    //     if(event.length > 0 && selectedEvent != null)
    //     {
    //             let t = event.find(t => {
    //             return t.id === selectedEvent;
    //         });
    //         setTemplates(t);
    //     }
    // }, [event]);

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true);
        const payload = cloneDeep(certificate);
        payload.templateData = template;
        payload.template = selectedEvent;
        payload.uuid = uuidv4()
        Api.updateCertificate(payload).then(response => {
            setCertificate(response)
            navigate('/certificates')
        }).catch(e => {
        }).finally(() => {
            setLoading(false);
        })
    };

    // const handleChange = (e => {
    //     let t = cloneDeep(certificate);
    //     t[e.target.id] = e.target.value; 
    //     setCertificate(t);
    // });

    return loading ? <LoadingSpinner /> : <div className='cerritificate-view-screen'>
        <div className='certificate-heading'>
            <Typography component="h1" variant="h5">
                Create Certificate
            </Typography>
        </div>
        <div className='certificate-add'>
            <Avatar sx={{m: 1, bgcolor: 'secondary.main'}}>
                <LockOutlinedIcon/>
            </Avatar>
            
            <div className='form' onSubmit={handleSubmit}>
                <Row>
                    <Col md={4}>
                        <Form.Group className="form-group">
                            {!isDisabled && <Form.Label>Event Name*</Form.Label>}
                            <input placeholder='Please Select' className='form-control WClick' type='text' value={selectedEvent?.name} hidden={isDisabled} onClick={()=>{setSelectedEvent()}} onChange={(e)=>{setSelectedEvent(e.target.value)}}/> 
                            {showSearch && <div className={'dropdown-content'}>
                                {selectedEvent != null && selectedEvent != "" && <div>Please Select</div> && event.map((e) => {
                                    if(typeof selectedEvent === "string" && e.name.toLowerCase().includes(selectedEvent.toLowerCase())){
                                        return <div onClick={()=>{
                                        setSelectedEvent(e)
                                        setTemplates(e.data);
                                        setTemplate(e.data[0]); 
                                    }}>{e.name}</div>   
                                }
                                })

                                }
                                {(selectedEvent == null || selectedEvent == "") && <div>Please Select</div> && event.map((e) => {
                                    return <div onClick={()=>{
                                        setSelectedEvent(e)
                                        setTemplates(e.data);
                                        setTemplate(e.data[0]);
                                    }}>{e.name}</div>
                                })}
                            </div>}
                            {/* <select id={"QW"} className="form-control1" value={selectedEvent?.id} hidden={isDisabled} disabled={isDisabled} onChange={(e) => {
                                if(e.target.value !== 'Please Select')
                                { 
                                let t = event.find(t => {
                                    return t.id.toString() ===  e.target.value.toString();
                                });
                                setSelectedEvent(t)
                                setTemplates(t.data);
                                setTemplate(t.data[0]);
                            }
                            else{
                                setTemplates(null);
                                setTemplate(null);
                            }
                            }}>
                                <option>Please Select</option>
                                {event.map((t) => {
                                    // <option value={t.id}>{t.name?.substring(0, 40)}</option>
                                    return <option value={t.id}>{t.name}</option>
                                })}
                            </select> */}
                        </Form.Group>
                    </Col>
                            
                    <Col md={4}>
                        <Form.Group className="form-group">
                            {!isDisabled && <Form.Label>Templates Name</Form.Label>}
                            <select className="form-control1" value={template?.TemplateName} hidden={isDisabled} onChange={(e) =>{
                                let t = templates?.find(t => {
                                    return t.TemplateName === e.target.value;
                                })
                                setTemplate(t);
                            }}>
                                <option>Please Select</option>
                                {templates?.map((t) => {
                                    return <option value={t.TemplateName}>{t.TemplateName}</option>
                                })}
                            </select>
                        </Form.Group>
                    </Col>
                    
                        {/* <Col md={4}>
                        <Form.Group>
                            <Form.Label>Student Name</Form.Label>
                            <input className='form-control' id={`student-name`}
                                value={certificate.data.name} onChange={e => {
                                let c = cloneDeep(certificate);
                                c.data.name = e.target.value;
                                setCertificate(c);
                            }}/>
                        </Form.Group>
                    </Col>*/}
                    <Col md={4}>
                        <Form.Group className="form-group">
                            <Form.Label>Student Email</Form.Label>
                            <input placeholder='Enter Student Email' className='form-control' 
                                id={`student-email`}value={certificate.data.email}
                                required onChange={e => {
                                let c = cloneDeep(certificate);
                                c.data.email = e.target.value;
                                setCertificate(c);
                            }}/>
                        </Form.Group>
                        </Col> 
                   
                    { template?.label?.map(label => {
                        return <Col md={4}>
                            <Form.Group className="form-group">
                                <Form.Label>{label.text}</Form.Label>
                                <textarea className='form-control' id={`label-${label.id}`}
                                    value={certificate.data[label.text]} onChange={e => {
                                    let c = cloneDeep(certificate);
                                    c.data[label.text] = e.target.value;
                                    setCertificate(c);
                                }}/>
                            </Form.Group>
                        </Col>
                    })}
                    
                     
                </Row>

                {  template &&
                <CertificateViewer id={id} qr={selectedEvent?.qr} 
                                backgroundImageUrl={template?.backgroundImageUrl}
                                labels={template?.label}
                                texts ={template?.Text}
                                images={template?.images}
                                qrCode={template?.qrCode}
                                data={certificate?.data}/>
                } 

            </div>
        
            <div className='Form-buttons-certificate'>
                <button className='cancel-certificate' onClick={()=>{navigate(-1)}}>Cancel</button>
                <Button
                    type="submit"
                    fullWidth onClick={handleSubmit}
                    disabled={loading}
                    variant="contained"
                    sx={{mt: 3, mb: 2}}
                >
                    {loading ? 'Please wait..' : `Send`}
                </Button>
            </div>
        </div>
    </div> 
}

export default withRouter(EditCertificate)
